module.exports = __webpack_public_path__ + "static/media/photo88.a872f8a6.jpg";